import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';

const faqs = [
  { q: 'Vocês atendem a domicílio?', a: 'Sim! Atendemos em João Pessoa e região. Basta entrar em contato pelo WhatsApp ou formulário e agendamos uma visita no melhor horário para você.' },
  { q: 'Quanto custa uma formatação?', a: 'O valor varia conforme o serviço. Entre em contato para receber um orçamento gratuito e sem compromisso. Trabalhamos com preços justos e transparentes.' },
  { q: 'Vocês fazem backup dos meus dados antes de formatar?', a: 'Sim! Antes de qualquer formatação, realizamos o backup dos seus arquivos importantes. Você decide o que quer salvar.' },
  { q: 'O suporte remoto é seguro?', a: 'Totalmente seguro. Utilizamos ferramentas profissionais de acesso remoto com criptografia. Você acompanha tudo em tempo real e pode encerrar a sessão a qualquer momento.' },
  { q: 'Atendem empresas com vários computadores?', a: 'Sim! Temos planos de manutenção preventiva e suporte técnico para empresas. Entre em contato para conhecer nossas soluções corporativas.' },
  { q: 'Qual o prazo para atendimento?', a: 'Geralmente respondemos em até 2 horas e agendamos o atendimento para o mesmo dia ou no dia seguinte, conforme disponibilidade.' },
  { q: 'Vocês vendem peças e componentes?', a: 'Sim! Trabalhamos com venda de peças e componentes para computadores e notebooks. Consulte disponibilidade e preços pelo WhatsApp.' },
  { q: 'Há garantia nos serviços realizados?', a: 'Sim! Todos os nossos serviços possuem garantia. Em caso de qualquer problema relacionado ao serviço prestado, retornamos sem custo adicional.' },
  { q: 'Atendem finais de semana?', a: 'Atendemos de segunda a sexta das 8h às 18h e aos sábados das 8h às 13h. Para urgências, entre em contato pelo WhatsApp.' },
  { q: 'Como funciona a montagem de PC gamer?', a: 'Você nos informa seu orçamento e necessidades. Indicamos os melhores componentes, compramos as peças e realizamos a montagem completa com instalação do sistema e testes.' },
];

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  name: 'Perguntas Frequentes - JampaBit Informática João Pessoa',
  description: 'Dúvidas sobre suporte técnico em TI em João Pessoa? Confira as perguntas mais comuns sobre os serviços da JampaBit Informática.',
  url: `${import.meta.env.VITE_SITE_URL}/faq`,
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
};

export default function FaqPage() {
  const [open, setOpen] = useState<number | null>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-faq';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-faq');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="bg-[#1a3a4a] pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 border border-[#00c9a7]/40 text-[#00c9a7] text-xs font-semibold px-4 py-2 rounded-full mb-6">
            <i className="ri-question-line" />
            Perguntas Frequentes
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-5">
            Dúvidas? <span className="text-[#00c9a7]">A Gente Responde!</span>
          </h1>
          <p className="text-white/60 text-lg max-w-xl mx-auto">
            Confira as perguntas mais comuns dos nossos clientes. Não encontrou sua dúvida? Fale conosco!
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="border border-gray-100 rounded-2xl overflow-hidden">
                <button
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-[#f0faf8] transition-colors"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span className="text-[#0d1b2a] font-semibold text-sm">{faq.q}</span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`${open === i ? 'ri-subtract-line text-[#00c9a7]' : 'ri-add-line text-gray-400'} text-lg`} />
                  </div>
                </button>
                {open === i && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-14 bg-[#1a3a4a] rounded-2xl p-8 text-center">
            <h3 className="text-white font-bold text-xl mb-3">Ainda tem dúvidas?</h3>
            <p className="text-white/60 text-sm mb-6">Fale diretamente com nossa equipe pelo WhatsApp ou envie uma mensagem.</p>
            <a
              href="https://wa.me/5583991755663?text=Olá!%20Tenho%20uma%20dúvida%20sobre%20os%20serviços%20da%20JampaBit."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-[#00c9a7] hover:bg-[#00b396] text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line" />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </section>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
